import script from "./sf-ellipsis.vue?vue&type=script&lang=ts&setup=true"
export * from "./sf-ellipsis.vue?vue&type=script&lang=ts&setup=true"

import "./sf-ellipsis.vue?vue&type=style&index=0&id=618268bc&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-618268bc"]])

export default __exports__